import { ReactNode } from 'react'

import { Icon, IconName } from 'components/Icon'

/** Full-viewport branded message for system states (404/403/500/offline/session-expired/loading) —
 *  self-contained so it renders correctly whether or not the app shell mounted. */
export const SystemMessage = ({
  icon,
  code,
  title,
  description,
  actions,
  footer,
}: {
  icon: IconName
  code?: string
  title: string
  description?: string
  actions?: ReactNode
  footer?: ReactNode
}) => (
  <div className="system-page">
    <div className="system-page__card">
      <span className="brand__mark" aria-hidden="true">
        JP
      </span>
      <span className="system-page__icon">
        <Icon name={icon} size={28} />
      </span>
      {code ? <p className="system-page__code">{code}</p> : null}
      <h1>{title}</h1>
      {description ? <p className="muted">{description}</p> : null}
      {actions ? <div className="system-page__actions">{actions}</div> : null}
      {footer ? <div className="system-page__footer">{footer}</div> : null}
    </div>
  </div>
)
